<template>
	<div class="d-flex flex-grow-1 overflow-hidden">
		<div
			class="flex-grow-1 d-flex flex-column px-2"
			style="border: 1px solid #eee"
		>
			<v-text-field
				label="Search"
				v-model="unassignedSearch"
				class="flex-grow-0"
			/>
			<v-list dense class="flex-grow-1 pa-0 overflow-auto">
				<v-subheader>Unassigned Users</v-subheader>
				<v-list-item-group
					v-model="selectedUnassigned"
					active-class="primary white--text"
					class="field-list"
					multiple
				>
					<v-list-item
						v-for="item in unassignedFiltered"
						:key="item.Id"
						:value="item.UserId"
					>
						<v-list-item-content>
							<v-list-item-title>{{
								`${item.UserFirstName} ${item.UserLastName}`
							}}</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list-item-group>
			</v-list>
		</div>
		<div class="flex-grow-0 d-flex">
			<div class="d-flex flex-column justify-center mx-4 flex-grow-1">
				<v-btn
					v-if="canEdit"
					class="my-2"
					color="primary"
					outlined
					text
					@click="assignUser()"
				>
					<v-icon> mdi-arrow-right </v-icon>
				</v-btn>
				<v-btn
					v-if="canEdit"
					class="my-2"
					color="primary"
					outlined
					text
					@click="unassignUser()"
				>
					<v-icon> mdi-arrow-left </v-icon>
				</v-btn>
			</div>
		</div>
		<div
			class="flex-grow-1 d-flex flex-column px-2"
			style="border: 1px solid #eee"
		>
			<v-text-field
				label="Search"
				v-model="assignedSearch"
				class="flex-grow-0"
			/>
			<v-list dense class="flex-grow-1 pa-0 overflow-auto">
				<v-subheader>Assigned users</v-subheader>
				<v-list-item-group
					v-model="selectedAssigned"
					active-class="primary white--text"
					class="field-list"
					multiple
				>
					<v-list-item
						v-for="item in assignedFiltered"
						:key="item.UserId"
						:value="item.UserId"
						class="px-1"
					>
						<v-list-item-content>
							<v-list-item-title
								>{{ item.FirstName }}
								{{ item.LastName }}</v-list-item-title
							>
						</v-list-item-content>
					</v-list-item>
				</v-list-item-group>
			</v-list>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import {
	ProjectContextGetters,
	ReportAssignUsersGetters,
} from '../../../../../store/getters';
import { ReportAssignUserActions } from '../../../../../store/actions';
import { Permissions } from '../../../../../enums/permissionsEnum';
import permissionsMixin from '../../../../../mixins/permissionsMixin';
export default {
	name: 'AssignUser',
	mixins: [permissionsMixin],
	props: {},
	data() {
		return {
			assignedSearch: '',
			unassignedSearch: '',
			selectedUnassigned: [],
			selectedAssigned: [],
		};
	},
	computed: {
		...mapGetters({
			assigned: [ReportAssignUsersGetters.ASSIGNED_USERS],
			unassigned: [ReportAssignUsersGetters.UNASSIGNED_USERS],
			selectedProject: [ProjectContextGetters.SELECTED_PROJECT],
			loading: [ReportAssignUsersGetters.IS_LOADING],
		}),
		assignedFiltered() {
			if (!this.assignedSearch) return this.assigned;
			return this.assigned.filter((x) => {
				let name = x.FirstName + ', ' + x.LastName;
				return name
					.toLowerCase()
					.includes(this.assignedSearch.toLowerCase());
			});
		},
		unassignedFiltered() {
			if (!this.unassignedSearch) return this.unassigned;
			return this.unassigned.filter((x) => {
				let name = x.UserFirstName + ', ' + x.UserLastName;
				return name
					.toLowerCase()
					.includes(this.unassignedSearch.toLowerCase());
			});
		},
		canView() {
			return this.hasPermissions([
				Permissions.Tools.ReportBuilder.Report.AssignUser.View,
			]);
		},
		canEdit() {
			return this.hasPermissions([
				Permissions.Tools.ReportBuilder.Report.AssignUser.Edit,
			]);
		},
	},
	mounted() {
		this.loadData();
	},
	methods: {
		assignUser() {
			this.$store
				.dispatch(ReportAssignUserActions.INSERT, {
					reportId: this.$route.params.reportId,
					users: this.selectedUnassigned,
				})
				.then(() => {
					this.loadData();
					(this.selectedUnassigned = []),
						(this.selectedAssigned = []);
				});
		},
		unassignUser() {
			this.$store
				.dispatch(ReportAssignUserActions.DELETE, {
					reportId: this.$route.params.reportId,
					users: this.selectedAssigned,
				})
				.then(() => {
					this.loadData();
					(this.selectedUnassigned = []),
						(this.selectedAssigned = []);
				});
		},
		onCancel() {
			this.$emit('cancel');
		},
		loadData() {
			this.$store.dispatch(ReportAssignUserActions.LOAD, {
				reportId: this.$route.params.reportId,
				projectId: this.selectedProject.Id,
			});
		},
	},
};
</script>
